import { apiRequest } from '@/core';
import { type DeleteMemberRequestParams } from './types';

export const deleteMemberRequest = async ({
  memberId,
  propertyId,
}: DeleteMemberRequestParams) =>
  apiRequest<void>({
    endpoint: `api/members/${propertyId}/${memberId}`,
    method: 'DELETE',
  });
